import {MeService} from "App/store/MeService";
import {AnnonceMetierService} from "App/store/AnnonceMetierService";
import {AnnonceContratService} from "App/store/AnnonceContratService";
import {AnnonceSecteurService} from "App/store/AnnonceSecteurService";

export const meService = new MeService();
export const annonceMetierService = new AnnonceMetierService();
export const annonceContratService = new AnnonceContratService();
export const annonceSecteurService = new AnnonceSecteurService();